import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { IssueTypeSettingsViewTopBar } from "./TopBar"

export const issueTypeSettingsStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: IssueTypeSettingsViewTopBar,
}
